import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Providers/StoreProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/shared/Analytics/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/shared/Intercom/IntercomClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/shared/nav/NavigationAvatars/LoggedInAvatarClientPart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotLoggedInAvatar"] */ "/app/app/components/shared/nav/NavigationAvatars/NotLoggedInAvatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/shared/nav/NavigationClient/CartAndMenuButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/shared/nav/NavigationClient/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Newsletter"] */ "/app/app/components/shared/NewsletterBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntercomProvider"] */ "/app/app/utils/providers/IntercomProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/app/components/ui/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Snackbar"] */ "/app/components/ui/Snackbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/link/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/typography/text.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"900\"],\"subsets\":[\"latin\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/styles/globalStyles.css");
